import React,{useState,useRef,useEffect} from 'react'
import _ from 'lodash'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { 
  Form, 
  Input, 
  TextArea, 
  Button, 
  Select, 
  Label, 
  Dimmer, 
  Loader, 
  Icon, 
  Message, 
  Modal, 
  Checkbox, 
  Popup, 
  Table, 
  Search, 
  Segment,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownHeader,
  DropdownDivider
} from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL, ReportsMPDFUrl, WindowLocationBaseUrl } from '../../../../services/redirect'
import Paginations from '../../../../services/paginations'
import EntryList from '../../../../services/entries'
import Spinner from '../../../../services/spinner'
import AlertMessage from '../../../../services/alert'
import AlertConfirmation from '../../../../services/confirmation'
import { DropdownComponent } from '../../../../components/options'


import AddEmail from './add-email'
import SendEmail from './send-processed'

import AuthDenied from '../../../ErrorPage/denied'

export default function ProccessedOrderStatus(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [statusSpinner,setstatusSpinner] = useState(false);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
  }
  
  /*----------------------------------------
    Range Reports
  -----------------------------------------*/
  const limitRecords = 3000;
  const [rangeReports, setRangeReports] = useState([]); 
  function RangeReportsFunction(total){

     const totalRecords = total;
     const pageSize     = limitRecords;

      // Generate ranges
      const ranges = [];
      for (let i = 1; i <= totalRecords; i += pageSize) {
        ranges.push({ start: i, end: Math.min(i + pageSize - 1, totalRecords) });
      }
      setRangeReports(ranges);

  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){

    if(buttonclick==1){
      props.resetForm();
      TableList(defaultpage,search);
    }else{
      let value={
        is_Search:values.is_Search,
        admin_id:values.admin_id,
        status:values.status,
        date_order_from:values.date_order_from!=''?moment(new Date(values.date_order_from)).format('YYYY-MM-DD'):'',
        date_order_to:values.date_order_to!=''?moment(new Date(values.date_order_to)).format('YYYY-MM-DD'):'',
      }
      TableList(defaultpage,value);
    }
  }




  const [search, setsearch]  = useState({
      is_Search:false,
      admin_id:'',
      status:'',
      date_order_from:'',
      date_order_to:'',
      date_order_to_min:'',
	});


  const [list, setlist] = useState([]);
  const [defaultpage, setdefaultpage] = useState(1);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');
  

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});


	  function pagenumberfunction(page){
        //console.log(FormReference.current.values);
        setpagenumber(page);
        let value={
          is_Search:FormReference.current.values.is_Search,
          admin_id:FormReference.current.values.admin_id,
          status:FormReference.current.values.status,
          date_order_from:FormReference.current.values.date_order_from!=''?moment(new Date(FormReference.current.values.date_order_from)).format('YYYY-MM-DD'):'',
          date_order_to:FormReference.current.values.date_order_to!=''?moment(new Date(FormReference.current.values.date_order_to)).format('YYYY-MM-DD'):'',
        }
				TableList(page,value);
        
		}

		function listreload(){
        setpagenumber(defaultpage);
				TableList(defaultpage,search);
		}
    

		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
        axios.post('/admin/reports/processed-orders/status/request.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            RangeReportsFunction(obj.paginations.paginations.total_records);
            //console.log(obj.paginations);


            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	}


  

    /*------------------------------------------------------
        ADMIN DATA
  -------------------------------------------------------*/
  const [dataAdmin, setDataAdmin] = useState([]);
  function ProccessAdminData(){
    let formData = new FormData();
    formData.append('type','list_admin');
    axios.post('/admin/reports/processed-orders/status/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setDataAdmin(obj);
    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
}






  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [orderStatus, setorderStatus] = useState([]);
  const [accountType, setaccountType] = useState([]);

  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setorderStatus(source.order_status);
    setaccountType(source.account_type);
  }



   /*------------------------------------------------------
          ADD / EDIT MODAL
  -------------------------------------------------------*/
  const [isemail, setisemail] = useState(false);
  const [sendProcessed, setsendProcessed] = useState(false);

  function ClassModalBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }

  function CallbackModal(data){
    if(data.close){
      ClassModalBody(false);
      setsendProcessed(false);
      setisemail(false);
    }
    if(data.reload){
      TableList(pagenumber,search);
    }
  }


  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('49kgqvft618ydxzep');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
          ProccessAdminData();
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
    
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {statusSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {sendProcessed&&<SendEmail data={FormReference.current.values} total_data={totaldata} callback={CallbackModal}/>}

       {isemail&&<AddEmail callback={CallbackModal}/>}

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>


       <div className="app-page-title"><h1>Orders Status</h1></div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
        <Formik
          initialValues={search}
          onSubmit={handleSubmitForm}
          innerRef={FormReference}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {

         const CustomDateFrom = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_from}><i className='uil-calender icon'></i><input /></Input>
         );
         const CustomDateTo = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_to}><i className='uil-calender icon'></i><input /></Input>
         );

         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                    <Form.Group widths="equal">

                        <Field name="date_order_from">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Date Order From</label>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                selected={values.date_order_from!=''?new Date(values.date_order_from):null}
                                onChange={date => {
                                   var dateselected 	= moment(new Date(date)).format('DD MMMM YYYY');
                                   var formindate 		= moment(new Date(date)).add(0, 'days');
                                   setFieldValue('date_order_to_min',new Date(formindate));
                                   setFieldValue('date_order_from',dateselected);
                                   setFieldValue('date_order_to',dateselected);
                                }}
                                customInput={<CustomDateFrom />}
                              />

                            </Form.Field>
                            )}
                        </Field>
                        <Field name="date_order_to">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Date Order To</label>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                selected={values.date_order_to!=''?new Date(values.date_order_to):null}
                                minDate={values.date_order_to_min}
                                onChange={date => {
                                  var dateselected 		= moment(new Date(date)).format('DD MMMM YYYY');
                                  setFieldValue('date_order_to',dateselected);
                                }}
                                customInput={<CustomDateTo />}
                              />
                            </Form.Field>
                            )}
                        </Field>

                        <Field name="status">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Status</label>
                              <Select selectOnBlur={false}
                                  {...field}
                                  options={orderStatus}
                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                            </Form.Field>
                            )}
                        </Field>

                        <Field name="admin_id">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Proccessed By</label>
                              <Select 
                                  selectOnBlur={false}
                                  search
                                  {...field}
                                  options={dataAdmin}
                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                            </Form.Field>
                            )}
                        </Field>

                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer grid">
                <div>
                  <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => {
                      buttonSubmit(1);
                      setpagenumber(defaultpage);
                      TableList(defaultpage,{
                        is_Search:false,
                        admin_id:'',
                        status:'',
                        date_order_from:'',
                        date_order_to:'',
                        date_order_to_min:''
                      });
                    }}/>
                    <Button type="button" icon='search' size='tiny' className="LightGrayButton" content='Search' onClick={() => {
                      if(values.date_order_from&&values.date_order_to){
                        setFieldValue('is_Search',true);
                      }
                      buttonSubmit(2)
                    }}/>
                    <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
                  </div>
                  <div>
                  </div>
              </div>
           </div>
      


      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>

      <div class="alert-message left info infohasborder" style={{'margin-bottom':'10px','margin-top':'5px'}}>
        <div><i class="info circle icon"></i></div>
        <div>
           <p style={{'text-transform':'uppercase','font-size':'20px','font-weight':'800'}}>Message Alert</p>
           <p>The Download Reports and Send to Email button will only be enabled if you apply a date range filter.</p>
        </div>
      </div>

      <div className="tableWrapper">
       <div className="panel-table">

         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div>


            {/*totaldata>limitRecords&&<Button disabled={list.length==0||!values.is_Search} size="tiny" className='BtnBasic reportsButton greenIcon' icon='uil-file-download' iconPosition='left'>
            <Dropdown
              text='DOWNLOAD REPORTS'
              scrolling
              floating
              labeled
              button
            >
              <DropdownMenu>
                <DropdownHeader icon='uil-file-download' content='Reports' />
                <DropdownDivider />
                {rangeReports.map((range, index) => (
                 <DropdownItem key={index}>
                    <a target="_blank" rel='noreferrer' 
                        href={WindowLocationBaseUrl('/')+'api/excel/reports/orders/orders_status/excelExport.php?date_from='+moment(new Date(values.date_order_from)).format('YYYY-MM-DD')+'&date_to='+moment(new Date(values.date_order_to)).format('YYYY-MM-DD')+'&id='+values.admin_id+'&status='+values.status+'&range_start='+range.start+'&range_end='+range.end}>Records From {range.start.toLocaleString()} - {range.end.toLocaleString()}
                    </a>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            </Button>*/}

            <Button disabled={list.length==0||!values.is_Search} as="a"
            href={WindowLocationBaseUrl('/')+'api/excel/reports/orders/orders_status/csvExport.php?date_from='+moment(new Date(values.date_order_from)).format('YYYY-MM-DD')+'&date_to='+moment(new Date(values.date_order_to)).format('YYYY-MM-DD')+'&id='+values.admin_id+'&status='+values.status}
            target="_blank"  size='tiny' className='BtnBasic greenIcon' icon='uil-file-download' content='DOWNLOAD REPORTS'/>
            
            <Button disabled={list.length==0||!values.is_Search} className="GreenButton" size='tiny' icon='uil-envelope-alt icon' content='SEND TO EMAIL' onClick={()=>{ setsendProcessed(true)}}/>
            <Button  className="GreenButton" size='tiny' icon='plus icon' content='Add Email' onClick={()=>{ setisemail(true)}}/>
           
           </div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive">
           <Table celled compact='very' className="ordersTable">
             <Table.Header>
               <Table.Row verticalAlign='middle'>
                 <Table.HeaderCell>Date</Table.HeaderCell>
                 <Table.HeaderCell>Order Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Type</Table.HeaderCell>
                 <Table.HeaderCell>Pharmacy</Table.HeaderCell>
                 <Table.HeaderCell>Product Code</Table.HeaderCell>
                 <Table.HeaderCell>Product</Table.HeaderCell>
                 <Table.HeaderCell>Quantity</Table.HeaderCell>
                 <Table.HeaderCell>Status</Table.HeaderCell>
                 <Table.HeaderCell>Processed By</Table.HeaderCell>
               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='10' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top'>
                         <Table.Cell className="now-wrapp" negative={data.status==1} warning={data.status==2} positive={data.status==3}>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.date_order}</h3>
                                  <p>{data.time_order}</p>
                              </div>
                            </div>
                         </Table.Cell>
                         <Table.Cell negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.order_number}</Table.Cell>
                         <Table.Cell negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.account_number}</Table.Cell>

                         <Table.Cell className="now-wrapp" negative={data.status==1} warning={data.status==2} positive={data.status==3}>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.account_type}</h3>
                                  <p>{data.reference_code}</p>
                              </div>
                            </div>
                         </Table.Cell>

                         <Table.Cell negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.account_name}</Table.Cell>
                         <Table.Cell negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.product_code}</Table.Cell>
                         <Table.Cell negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.product_name}</Table.Cell>
                         <Table.Cell collapsing negative={data.status==1} warning={data.status==2} positive={data.status==3}>{data.quantity}</Table.Cell>

                         <Table.Cell className="now-wrapp" negative={data.status==1} warning={data.status==2} positive={data.status==3}>{parse(data.statusHtml)}</Table.Cell>
                         <Table.Cell className="now-wrapp" negative={data.status==1} warning={data.status==2} positive={data.status==3}>
                            <div className="infoProcess"><p>{data.info_process}</p></div>
                         </Table.Cell>
                         
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='10'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

        </React.Fragment>
        )}}
        </Formik>

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
